/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ParticipantEmailComponent from './participant.email.component';
import { clearUpdateParticipantEmailError, hideModal, updateParticipantEmail } from '../../actions/actions';

export const mapStateToProps = (state) => {
  return {
    error: state.subject.errorUpdateParticipantEmail,
    isLoading: state.subject.isLoadingParticipantEmail,
    participantJourney: state.subject.participantJourney
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    hide: () => {
      dispatch(hideModal());
      dispatch(clearUpdateParticipantEmailError());
    },
    updateParticipantEmail: (participantJourneyGid, payload) => {
      dispatch(updateParticipantEmail(participantJourneyGid, payload));
    }
  };
};

const ParticipantEmailModalContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantEmailComponent);

export default ParticipantEmailModalContainer;
